import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const MediaPlannerIcon = {
  name: 'MediaPlannerIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || (s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x');
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;

    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "10 0 40 35",
        fill: "none"
      },
      class: "custom-icon"
    }, ctx.data]), [
      h("g", {
        attrs: {
          "clip-path": "url(#clip0)"
        }
      }, [
        h("path", {
          attrs: {
            d: "M44.4383 20.6367C45.0201 20.9636 45.5519 21.3684 46.0203 21.8368C47.3346 23.1503 48.1468 24.966 48.1468 26.9697V31.0966C48.1468 31.6005 47.7378 32.0095 47.2339 32.0095H34.5399C34.036 32.0095 33.627 31.6005 33.627 31.0966V26.9697C33.627 24.2504 35.1226 21.8799 37.3346 20.6367",
            stroke: "white",
            "stroke-width": "0.7",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M31.6276 28.3254H12.6113C11.4773 28.3254 10.5576 27.4057 10.5576 26.2708V8.04588C10.5576 6.9119 11.4773 5.99219 12.6113 5.99219H42.2184C43.3532 5.99219 44.273 6.9119 44.273 8.04588V10.3918",
            stroke: "white",
            "stroke-width": "0.7",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M15.7546 10.1152H13.9312C13.606 10.1152 13.3418 10.3795 13.3418 10.7047V12.528C13.3418 12.8532 13.606 13.1174 13.9312 13.1174H15.7546C16.0798 13.1174 16.344 12.8532 16.344 12.528V11.9335",
            stroke: "white",
            "stroke-width": "0.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M15.7546 19.9102H13.9312C13.6057 19.9102 13.3418 20.1741 13.3418 20.4996V22.3229C13.3418 22.6485 13.6057 22.9124 13.9312 22.9124H15.7546C16.0801 22.9124 16.344 22.6485 16.344 22.3229V20.4996C16.344 20.1741 16.0801 19.9102 15.7546 19.9102Z",
            stroke: "white",
            "stroke-width": "0.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M18.2568 11.6172H34.0817",
            stroke: "white",
            "stroke-width": "0.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M14.1826 10.9587L15.1828 12.2621L17.029 10.1152",
            stroke: "white",
            "stroke-width": "0.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M15.7546 15.0137H13.9312C13.606 15.0137 13.3418 15.2779 13.3418 15.6031V17.4264C13.3418 17.7517 13.606 18.0159 13.9312 18.0159H15.7546C16.0798 18.0159 16.344 17.7517 16.344 17.4264V16.8319",
            stroke: "white",
            "stroke-width": "0.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M14.1826 15.8563L15.1828 17.1605L17.029 15.0137",
            stroke: "white",
            "stroke-width": "0.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M18.2568 16.5137H33.1739",
            stroke: "white",
            "stroke-width": "0.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M18.2568 21.4121H34.0817",
            stroke: "white",
            "stroke-width": "0.5",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
          }
        }),
        h("path", {
          attrs: {
            d: "M40.8874 20.9251C43.6923 20.9251 45.9661 18.6513 45.9661 15.8463C45.9661 13.0414 43.6923 10.7676 40.8874 10.7676C38.0824 10.7676 35.8086 13.0414 35.8086 15.8463C35.8086 18.6513 38.0824 20.9251 40.8874 20.9251Z",
            stroke: "white",
            "stroke-width": "0.7",
            "stroke-miterlimit": "10",
            "stroke-linecap": "round"
          }
        })
      ]),
      h("defs", [
        h("clipPath", {
          attrs: {
            id: "clip0"
          }
        }, [
          h("rect", {
            attrs: {
              width: "38.0971",
              height: "26.5236",
              fill: "white",
              transform: "translate(10.3037 5.73828)"
            }
          })
        ])
      ])
    ]);
  }
};

export default MediaPlannerIcon;
